import React, { useEffect, useState } from 'react';
import {
  FaAngleDoubleUp,
  FaAngleDoubleDown,
  FaMapMarkerAlt,
  FaComments,
  FaShare,
} from 'react-icons/fa';
import DEPART_DIC from '../constants/DepartDic';
import {
  beautyReefHotelList,
  noWindHotelList,
} from '../constants/EgypetCollectionHotelsList';
import formatNumber from '../utils/formatNumber';
import OneTour from './OneTour';
import GroupedByRoomTours from './GroupedByRoomTours';
import FlightsClock from '../../../shared/components/FlightsClock';
import GeoclientTourButton from '../components/Geoclient/GeoclientTourButton';
import { TbPlaneDeparture } from 'react-icons/tb';
import {
  MdOutlineNightlight,
  MdFastfood,
  MdOutlineHotel,
} from 'react-icons/md';
import { BsFillLightningChargeFill, BsPeopleFill } from 'react-icons/bs';
import $ from 'jquery';
import { ShareModal } from '../components/ShareModal/ShareModal';
import { CURRENCY_MAP_ICON } from '../constants/CurrencyClasses';
import { Link } from 'react-router-dom';
import { IoWarning } from 'react-icons/io5';
import { AiFillLike, AiOutlineClose } from 'react-icons/ai';
import composeOneTour from '../components/utils/composeOneTour';

const OneHotelView = ({
  row,
  departure,
  requestModel,
  geoclient,
  recomend = false,
  onAction,
  onContinue,
  sort,
  onSort,
  getHotelInfo,
  filteredOperators,
  hasGeograftourReviews,
}) => {
  const [isOpen, setOpen] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);
  const [tourToShare, setTourToShare] = useState(null);
  const [roomList, setRoomList] = useState([]);
  const [groupedTours, setGroupedTours] = useState([]);
  const [toursLength, setToursLength] = useState(0);
  const [isHotelCardHidden, setHotelCardHidden] = useState(false);

  useEffect(() => {
    if (row.tours.tour && row.tours.tour.length !== toursLength) {
      setToursLength(row.tours.tour.length);
      groupToursByRoom(row.tours.tour);
    }
  }, [row.tours.tour.length, filteredOperators]);

  if (row.tours.tour?.length < 1) {
    return;
  }

  const tourAgencyBaseUrl =
    'https://www.geograftour.com/tours/agency-tour-info/';
  const logoBaseUrl =
    'https://www.geograftour.com/static/index/img/touroperator/tourvisor/';

  const toggleTours = () => {
    setOpen(!isOpen);
  };

  const handleContinue = (e) => {
    $(e.target).hide();
    onContinue();
  };

  function groupToursByRoom(tourList) {
    setToursLength(tourList.length);
    let roomList = [];
    tourList.forEach((tour) =>
      roomList.includes(tour.room) ? false : roomList.push(tour.room)
    );
    setRoomList(roomList);
    let group = {};
    for (let i = 0; i < tourList.length; i++) {
      let tour = tourList[i];

      if (group.hasOwnProperty(tour.room)) {
        group[tour.room].push(tour);
      } else {
        group[tour.room] = [tour];
      }
    }
    setGroupedTours(group);
  }

  function hideHotelCard() {
    setHotelCardHidden(!isHotelCardHidden);
  }

  const parseOneHotelTours = (item) => {
    const hotel = composeOneTour(
      item,
      filteredOperators,
      departure,
      requestModel
    );
    return hotel;
  };

  const row_fix = parseOneHotelTours(row);

  return (
    <>
      {tourToShare ? (
        <ShareModal
          row={tourToShare}
          open={isOpenModal}
          handleClose={() => {
            setOpenModal(false);
            setTourToShare(null);
          }}
        />
      ) : null}
      <article
        className={`tour-hotel__card ${
          isHotelCardHidden ? 'tour-hotel__card_hidden' : ''
        } ${recomend}`}
      >
        <AiOutlineClose
          title="Скрыть данный отель"
          className="hotel-card__close-btn"
          onClick={hideHotelCard}
        ></AiOutlineClose>
        <div className="tour-hotel__image-wrap">
          <div className="tour-hotel__image clickable">
            <img
              alt={`Фото отеля ${row.hotelname}`}
              className="tour-hotel__image-item"
              id={row.hotelcode}
              title={row.hotelcode}
              src={row_fix.row.hotel_image_src}
              onClick={(e) => getHotelInfo(e.target.id)}
              loading="lazy"
            />
            <div className="icon-bar">
              <div className="social-bar social">
                <FaShare
                  title={'Поделиться туром'}
                  className="social-bar__icon share-icon"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenModal(true);
                    setTourToShare(row_fix.row);
                  }}
                />
                <FaComments
                  className="social-bar__icon"
                  onClick={() => getHotelInfo(row.hotelcode, 3)}
                  title="Отзывы туристов"
                />
                <FaMapMarkerAlt
                  className="social-bar__icon"
                  onClick={() => getHotelInfo(row.hotelcode, 1)}
                  title="Отель на карте"
                />
                {!!hasGeograftourReviews ? (
                  <div
                    className="tour__georeview"
                    title="Отзывы от Географии"
                    onClick={() => {
                      getHotelInfo(row.hotelcode, 2);
                    }}
                  >
                    <img
                      src="https://geograftour.com/static/index/img/geoclient/geo-simple-logo.webp"
                      alt=""
                      loading="lazy"
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className={'hotel-card__badges'}>
            {row_fix.row.promo ? (
              <span className="hotel-card__promo-mobile hotel-card__promo-mobile">
                ПРОМО
              </span>
            ) : null}
            {!!recomend ? (
              <div className="tour__geolike tour__badge">
                <AiFillLike title="Рекомендуем" />
              </div>
            ) : null}
          </div>
        </div>
        <div className="tour-hotel">
          <div className="tour-hotel__info">
            <div
              className="tour-hotel__title"
              id={row.hotelcode}
              onClick={() => {
                getHotelInfo(row.hotelcode);
              }}
            >
              <p>
                {row_fix.row.country_name}, {row_fix.row.town_name},
                {row_fix.row.seadistance && (
                  <span>
                    <small>
                      {' '}
                      <b>{row_fix.row.seadistance}</b>м до моря
                    </small>
                  </span>
                )}
                {+row_fix.row.hotelrating > 0 ? (
                  <span className="rating" title="Средняя оценка отеля">
                    {parseFloat(row_fix.row.hotelrating, 2)}
                  </span>
                ) : (
                  ''
                )}
              </p>
              <p className="hotelname" style={{ fontSize: '16px' }}>
                <span className="hotelstars">{row_fix.row.star_id}*</span>{' '}
                <b>
                  <span id={row.hotelcode} title={row.hotelcode}>
                    {row_fix.row.hotel_name}
                  </span>
                </b>
              </p>
            </div>
            <div className="tour-hotel__badge-feature">
              {row_fix.row.country_id === 1 &&
              beautyReefHotelList.includes(+row.hotelcode) ? (
                <span style={{ background: '#fc6464' }}>Красивый риф</span>
              ) : null}
              {row_fix.row.country_id === 1 &&
              noWindHotelList.includes(+row.hotelcode) ? (
                <span style={{ background: '#009abc' }}>Бухта без ветра</span>
              ) : null}
            </div>
            <div className="tour-hotel__data">
              <p>
                <MdOutlineNightlight /> {row_fix.row.dt1} - {row_fix.row.dt2} (
                {row_fix.row.nights} ночей){' '}
              </p>
              <p>
                <BsPeopleFill /> {row.tours.tour[0].placement}
                {' | '}
                <MdFastfood />{' '}
                {row_fix.row.meal_id === 9067
                  ? row_fix.row.meal_full
                  : `${row_fix.row.meal_name} - ${row_fix.row.meal_full}`}
              </p>
              <p></p>
              <p>
                <MdOutlineHotel /> {row_fix.row.room_id}{' '}
              </p>
            </div>
          </div>
          <div className="tour-hotel__flight">
            <div className="tour-hotel__flight-point tour-hotel__flight-from">
              <TbPlaneDeparture />
              {DEPART_DIC[departure]?.id !== 99
                ? `Вылет из ${DEPART_DIC[departure]?.name_from}`
                : 'Без перелета'}
            </div>
            {String(departure) !== '99' ? (
              <>
                <div className="tour-hotel__flight-point tour-hotel__flight-type">
                  {row.tours.tour[0].regular === 1 ? (
                    <>
                      <IoWarning className="tour-hotel__flight-point-warning" />
                      <span>Рейс регулярный, возможны доплаты</span>
                      <FlightsClock tour_id={row.tours.tour[0].tourid} />
                    </>
                  ) : (
                    <>
                      <span className="tour-hotel__flight-type-charter">
                        Чартер
                      </span>
                      <FlightsClock tour_id={row.tours.tour[0].tourid} />
                    </>
                  )}
                </div>
                {row.tours.tour[0].fuelcharge ? (
                  <div className="tour-hotel__flight-point tour-hotel__flight-fuel">
                    Включен топливный сбор:{' '}
                    <span>
                      {row.tours.tour[0].fuelcharge}{' '}
                      {row.tours.tour[0].currency}
                    </span>
                  </div>
                ) : null}
              </>
            ) : null}
            <div className="tour-hotel__flight-point tour-hotel__flight-tourname">
              {row.tours.tour[0].tourname}
            </div>
          </div>
          <div className="tour-hotel__price">
            <div className="operator__image">
              {!requestModel.hideoperator ? (
                <img
                  src={`${logoBaseUrl}${row.tours.tour[0].operatorcode}.png`}
                  alt={row.tours.tour[0].operatorname}
                  loading="lazy"
                />
              ) : null}
            </div>
            <GeoclientTourButton
              tour={row_fix.row}
              geoclient={geoclient}
              onAction={onAction}
            />
            <Link
              to={`${tourAgencyBaseUrl}${row.tours.tour[0].tourid}/?currency=${row.tours.tour[0].currency}`}
              className="btn__info"
              target="_blank"
            >
              <span className="price">
                {formatNumber(row.tours.tour[0].price)}
                <small>{CURRENCY_MAP_ICON[row.tours.tour[0].currency]}</small>
                <span>Забронировать</span>
              </span>
              {row.tours.tour[0].hotelstatus === 2 ? (
                <span className="tour-hotel__permanent-booking-container">
                  <BsFillLightningChargeFill
                    className="tour-hotel__permanent-booking"
                    title="Мгновенное бронирование"
                  />
                </span>
              ) : null}
            </Link>
            <div onClick={toggleTours} className="toggle-tour">
              {isOpen ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />}
              Все цены (<b>{row.tours.tour?.length}</b>)
            </div>
          </div>
          {row.hoteldescription?.length ? (
            <div className="tour-hotel__description">
              {row.hoteldescription}
            </div>
          ) : null}
        </div>
      </article>
      {isOpen ? (
        <>
          {row.tours.tour.length && sort === 'price' ? (
            <button
              className="tours__group-button"
              onClick={() => onSort('room')}
            >
              Группировать по типу номера
            </button>
          ) : (
            <button
              className="tours__group-button"
              onClick={() => onSort('price')}
            >
              Группировать по стоимости
            </button>
          )}
        </>
      ) : null}
      {isOpen && sort === 'room' ? (
        <div>
          <GroupedByRoomTours
            row_fix={row_fix}
            row={row}
            groupedTours={groupedTours}
            roomList={roomList}
            hideoperator={requestModel.hideoperator}
            geoclient={geoclient}
            onContinue={handleContinue}
            onAction={onAction}
            setOpenModal={setOpenModal}
            setTourToShare={setTourToShare}
          />
        </div>
      ) : (
        <>
          {isOpen && row.tours.tour.length && (
            <div className="hotel_hidden_list1">
              {row.tours.tour.map((tour) => {
                return (
                  <OneTour
                    tour_id={tour.tourid}
                    key={tour.tourid}
                    row_fix={row_fix}
                    row={row}
                    hideoperator={requestModel.hideoperator}
                    geoclient={geoclient}
                    onAction={onAction}
                    tour={tour}
                    setOpenModal={setOpenModal}
                    setTourToShare={setTourToShare}
                  />
                );
              })}
              {row.tours.tour.length > 3 ? (
                <div style={{ textAlign: 'center' }}>
                  <button
                    className="btn__search-tour-more"
                    style={{ padding: '5px 10px', fontSize: 12 }}
                    onClick={handleContinue}
                  >
                    Еще туры
                  </button>{' '}
                </div>
              ) : null}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default OneHotelView;
